<template>
  <Wrapper>
    <header>
      <div class="tabs tabs--bottom desktop">
        <span
          class="tab tab--main"
          :class="{ 'tab-active': $route.name === 'users' }"
          @click="setRoute('users')"
        >
          Потребители
        </span>
        <span
          class="tab tab--main"
          :class="{ 'tab-active': $route.name === 'roles' }"
          @click="setRoute('roles')"
        >
          Роли
        </span>
      </div>
    </header>
    <div class="table-wrapper table-wrapper--new">
      <router-view></router-view>
    </div>
  </Wrapper>
</template>

<script>
import { getAccess } from './mixins/getAccess';
import Wrapper from "./Wrapper.vue";
export default {
  components: {
    Wrapper,
  },
  methods: {
    setRoute(routeName) {
      let accessName = routeName === 'users' ? 'users_info' : 'users_roles'

      if(getAccess(accessName, 'users')) {
        this.$router.push({ name: routeName });
      } else {
        this.$snotify.warning('Нямате достъп!')
      }
    },
  },
};
</script>
